module.exports = __webpack_public_path__ + "img/empty-image.276c05f0.png";